/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArchitectureTypesEnum } from './ArchitectureTypesEnum';
import {
    ArchitectureTypesEnumFromJSON,
    ArchitectureTypesEnumFromJSONTyped,
    ArchitectureTypesEnumToJSON,
} from './ArchitectureTypesEnum';
import type { PackageWithDownloadSchema } from './PackageWithDownloadSchema';
import {
    PackageWithDownloadSchemaFromJSON,
    PackageWithDownloadSchemaFromJSONTyped,
    PackageWithDownloadSchemaToJSON,
} from './PackageWithDownloadSchema';
import type { ScanResultSchema } from './ScanResultSchema';
import {
    ScanResultSchemaFromJSON,
    ScanResultSchemaFromJSONTyped,
    ScanResultSchemaToJSON,
} from './ScanResultSchema';

/**
 * 
 * @export
 * @interface SoftwareEnvironmentSpecWithDownloadSchema
 */
export interface SoftwareEnvironmentSpecWithDownloadSchema {
    /**
     * 
     * @type {number}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    updated: Date;
    /**
     * 
     * @type {number}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    aliasId: number;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    md5: string;
    /**
     * 
     * @type {Array<PackageWithDownloadSchema>}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    packages: Array<PackageWithDownloadSchema>;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    containerUri?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    gpuEnabled: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    rawPip?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    rawConda?: string;
    /**
     * 
     * @type {number}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    latestBuildId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    useEntrypoint?: boolean;
    /**
     * 
     * @type {ArchitectureTypesEnum}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    architecture?: ArchitectureTypesEnum;
    /**
     * 
     * @type {ScanResultSchema}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    scanResult?: ScanResultSchema;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    creator?: string;
    /**
     * 
     * @type {number}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    creatorId?: number;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    pythonSpecifier?: string;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    lockfileName?: string;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    lockfileContent?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SoftwareEnvironmentSpecWithDownloadSchema
     */
    enableExperimentalInstaller: boolean;
}

/**
 * Check if a given object implements the SoftwareEnvironmentSpecWithDownloadSchema interface.
 */
export function instanceOfSoftwareEnvironmentSpecWithDownloadSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "aliasId" in value;
    isInstance = isInstance && "md5" in value;
    isInstance = isInstance && "packages" in value;
    isInstance = isInstance && "gpuEnabled" in value;
    isInstance = isInstance && "enableExperimentalInstaller" in value;

    return isInstance;
}

export function SoftwareEnvironmentSpecWithDownloadSchemaFromJSON(json: any): SoftwareEnvironmentSpecWithDownloadSchema {
    return SoftwareEnvironmentSpecWithDownloadSchemaFromJSONTyped(json, false);
}

export function SoftwareEnvironmentSpecWithDownloadSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SoftwareEnvironmentSpecWithDownloadSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'aliasId': json['alias_id'],
        'md5': json['md5'],
        'packages': ((json['packages'] as Array<any>).map(PackageWithDownloadSchemaFromJSON)),
        'containerUri': !exists(json, 'container_uri') ? undefined : json['container_uri'],
        'gpuEnabled': json['gpu_enabled'],
        'rawPip': !exists(json, 'raw_pip') ? undefined : json['raw_pip'],
        'rawConda': !exists(json, 'raw_conda') ? undefined : json['raw_conda'],
        'latestBuildId': !exists(json, 'latest_build_id') ? undefined : json['latest_build_id'],
        'useEntrypoint': !exists(json, 'use_entrypoint') ? undefined : json['use_entrypoint'],
        'architecture': !exists(json, 'architecture') ? undefined : ArchitectureTypesEnumFromJSON(json['architecture']),
        'scanResult': !exists(json, 'scan_result') ? undefined : ScanResultSchemaFromJSON(json['scan_result']),
        'creator': !exists(json, 'creator') ? undefined : json['creator'],
        'creatorId': !exists(json, 'creator_id') ? undefined : json['creator_id'],
        'pythonSpecifier': !exists(json, 'python_specifier') ? undefined : json['python_specifier'],
        'lockfileName': !exists(json, 'lockfile_name') ? undefined : json['lockfile_name'],
        'lockfileContent': !exists(json, 'lockfile_content') ? undefined : json['lockfile_content'],
        'enableExperimentalInstaller': json['enable_experimental_installer'],
    };
}

export function SoftwareEnvironmentSpecWithDownloadSchemaToJSON(value?: SoftwareEnvironmentSpecWithDownloadSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'alias_id': value.aliasId,
        'md5': value.md5,
        'packages': ((value.packages as Array<any>).map(PackageWithDownloadSchemaToJSON)),
        'container_uri': value.containerUri,
        'gpu_enabled': value.gpuEnabled,
        'raw_pip': value.rawPip,
        'raw_conda': value.rawConda,
        'latest_build_id': value.latestBuildId,
        'use_entrypoint': value.useEntrypoint,
        'architecture': ArchitectureTypesEnumToJSON(value.architecture),
        'scan_result': ScanResultSchemaToJSON(value.scanResult),
        'creator': value.creator,
        'creator_id': value.creatorId,
        'python_specifier': value.pythonSpecifier,
        'lockfile_name': value.lockfileName,
        'lockfile_content': value.lockfileContent,
        'enable_experimental_installer': value.enableExperimentalInstaller,
    };
}

